import http from "@/http";
import {endLoadTable, Forbidden, getUrl} from "@/components/composables/functions";
import {endLoading} from "@/components/composables/spinners";
import {notifySuccess} from "@/components/composables/messages";

export const state = {
    listAll: {},
    listCards: [],
    pagination: {
        page: 0,
        limit: 25,
        total: 1,
        partial: 0,
    },
    showModalForm: false,
    submitted: false,
    loading: false,
}

export const mutations = {
    getList(state, newValue) {
        state.listAll = newValue.data

        state.pagination = {
            page: newValue.page,
            limit: newValue.per_page,
            total: newValue.count,
            start: newValue.count > 0 ? newValue.page * newValue.per_page + 1 : 0,
            partial: newValue.count > 0 ? newValue.page * newValue.per_page + newValue.data.length : 0,
        }
    },

    getValues(state, newValue) {
        state.listAll = newValue
    },

    resetValues(state) {
        state.listAll = null;
        state.listCards = [];
    },

    setPagination(state, value) {
        state.pagination = value;
    },

    changeShowModalForm(state, value) {
        state.showModalForm = value;
    },

    startLoading(state) {
        state.loading = true;
    },

    startSubmit(state) {
        state.submitted = true;
    },

    endSubmit(state) {
        state.submitted = false;
    },

    startProcessing(state) {
        state.loading = true;
        state.submitted = true;
    },

    endProcessing(state) {
        state.loading = false;
        state.submitted = false;
    },

    endLoading(state) {
        state.loading = false;
    },

}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    getApi({commit}, url) {
        http.get(url, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then(response => {
                commit('getList', response.data);
                endLoadTable();
                if (document.getElementById('spinnerTable')) document.getElementById('spinnerTable').style.display = 'none';
            })
            .catch(error => {
                endLoadTable();
                console.error('store - getApi: ', error);
                Forbidden(error);
            })
    },

    getCards({commit}, url) {
        if (document.getElementById('spinnerTable')) document.getElementById('spinnerTable').style.display = 'block';
        http.get(url, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then(response => {
                commit('getCards', response.data);
                localStorage.setItem('token', response.data.token)
                endLoadTable();
                if (document.getElementById('spinnerTable')) document.getElementById('spinnerTable').style.display = 'none';
            })
            .catch(error => {
                endLoadTable();
                console.error('store - getCards: ', error);
                Forbidden(error);
            })
    },

// eslint-disable-next-line
    async insert({dispatch, commit}, data) {
        let url = data.url;
        let formData = data.formData;
        if (formData.id > 0) {
            url += `/${formData.id}`;
            formData._method = 'PUT';
            delete formData.password;
        }
        return await http.post(url, formData, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then((response) => {
                notifySuccess(response.data.message);
                return true;
            })
            .catch(error => {
                console.error('store - insert: ', error);
                Forbidden(error);
                return false;
            })
            .finally(() => {
                endLoading('form', 'save');
            })
    },

    async delete({dispatch}, data) {
        const session = JSON.parse(localStorage.getItem(data.session));
        const id = data.id;
        let url = `${session.url}/${id}`;
        return await http.delete(url, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then((response) => {
                url = getUrl(data.session);
                dispatch('getApi', url);
                notifySuccess(response.data.message);
            })
            .catch(error => {
                console.error('store - delete: ', error);
                Forbidden(error);
            })
    }
}
